export default __webpack_public_path__ + "static/media/119-ocean-waves.760d8a9b.jpeg";